// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"Widget-component-module__tooltip___kta2m"};